import { z } from "zod";

export const FEEDBACK_MESSAGE_MAX_LENGTH = 5000;

const SendFeedbackDtoSchema = z.object({
  message: z.string().trim().min(1).max(FEEDBACK_MESSAGE_MAX_LENGTH),
  allow_contact: z.boolean(),
});

export const SendFeedbackRequestSchema = z.object({
  message: z.string().trim().min(1, "Write your feedback before sending.")
    .max(FEEDBACK_MESSAGE_MAX_LENGTH, `Use no more than ${FEEDBACK_MESSAGE_MAX_LENGTH} characters.`),
  allowContact: z.boolean(),
});

export type SendFeedbackDto = z.infer<typeof SendFeedbackDtoSchema>;
export type SendFeedbackRequest = z.infer<typeof SendFeedbackRequestSchema>;
export interface FeedbackReceiptDto {
  sent: true;
}

export function fromSendFeedbackRequestToSendFeedbackDto(request: SendFeedbackRequest): SendFeedbackDto {
  const feedback = SendFeedbackRequestSchema.parse(request);
  return SendFeedbackDtoSchema.parse({ message: feedback.message, allow_contact: feedback.allowContact });
}
